module.exports = __webpack_public_path__ + "img/baby_1.dde19fe7.jpg";